module.exports = __webpack_public_path__ + "static/Updated_FY_2025_Financial_Pages_HSE_Investment_sarl_audited-ed79fb23b47031c89874584c9fd529d6.pdf";